export const financeData = [
        {
        year: 2025,
        description1: 'Бухгалтерская отчетность',
        file1: 'finances/financial_report_2025.pdf',
        description2: 'Отчетность по домам',
        file2: 'finances/year_report_2025.zip',
    },
    {
        year: 2024,
        description1: 'Бухгалтерская отчетность',
        file1: 'finances/financial_report_2024.pdf',
        description2: 'Отчетность по домам',
        file2: 'finances/year_report_2024.zip',
    },

    {
        year: 2023,
        description1: 'Бухгалтерская отчетность',
        file1: 'finances/financial_report_2023.pdf',
        description2: 'Отчетность по домам',
        file2: 'finances/year_report_2023.zip',
    },

    {
        year: 2022,
        description1: 'Бухгалтерская отчетность',
        file1:'finances/financial_report_2022.pdf',
        description2: 'Отчетность по домам',
        file2: 'finances/year_report_2022.zip',
    },

    {
        year: 2021,
        description1: 'Бухгалтерская отчетность',
        file1: 'finances/financial_report_2021.pdf',
        description2: 'Отчетность по домам',
        file2: 'finances/year_report_2021.zip',
    },

    {
        year: 2020,
        description1: 'Бухгалтерская отчетность',
        file1: 'finances/financial_report_2020.pdf',
        description2: 'Отчетность по домам',
        file2: 'finances/year_report_2020.zip',
    },

    {
        year: 2019,
        description1: 'Бухгалтерская отчетность',
        file1: 'finances/financial_report_2019.pdf',
        description2: 'Отчетность по домам',
        file2: 'finances/year_report_2019.zip',
    },

    {
        year: 2018,
        description1: 'Бухгалтерская отчетность',
        file1: 'finances/financial_report_2018.pdf',
        description2: 'Отчетность по домам',
        file2: 'finances/year_report_2018.zip',
    },

    {
        year: 2017,
        description1: 'Бухгалтерская отчетность',
        file1: 'finances/financial_report_2017.pdf',
        description2: 'Отчетность по домам',
        file2: 'finances/year_report_2017.zip',
    }

]